/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line
  const menuItems = document.querySelectorAll('.menuMobile__wrapper > button .sliderule__chevron--down');
  const menuSubItems = document.querySelectorAll('.menuMobile__wrapper-2 .sliderow__title') || document.querySelectorAll('.menuMobile__wrapper-2 .sliderow__title > span'); 
  // process event click
  menuItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault(); 

      const parentItem = this.closest('.sliderow-mobile');
      if (!parentItem) return;
      const subMenu = parentItem.nextElementSibling;
      const parentMenuItem = subMenu.parentElement;
      if (subMenu && subMenu.classList.contains('mobile__menu__dropdown')) {
        const siblingMenus = parentMenuItem.parentElement.querySelectorAll('.mobile__menu__dropdown.active');
        siblingMenus.forEach(otherSubMenu => {
          console.log("otherSubMenu")
          if (otherSubMenu !== subMenu) {
            otherSubMenu.classList.remove('active');
            otherSubMenu.parentElement.classList.remove('show');
          }
        });
        subMenu.classList.toggle('active');
        parentMenuItem.classList.toggle('show');
        if (parentMenuItem.classList.contains('color-base') && !parentMenuItem.classList.contains('show')) {
          parentMenuItem.classList.remove('color-base');
        }
      }


    });
  });

  menuSubItems.forEach(item => {
    item.addEventListener('click', (e) => {
      
      e.preventDefault();
    //  console.log(e, e.target.parentElement)
      parentMenuItem = e.target.closest('.menuMobile__wrapper-2');
      if (parentMenuItem) {
        const grandMenuItem = parentMenuItem.closest('.menuMobile__wrapper-1');
        if (grandMenuItem) {
          grandMenuItem.classList.add('color-base');
        }
      }
      setTimeout(() => {
        if (e.target.nodeName == 'A') {
          console.log(e.target.href)
          window.location.href = e.target.href;
        }
        else if(e.target.nodeName == 'SPAN'){
          console.log(e.target.parentElement.href)
          window.location.href = e.target.parentElement.href;
        }
      }, 100);
    });
  });

  // toogle class product__variant-toggle
  window.addEventListener('DOMContentLoaded', () => {
    const variantToggles = document.querySelectorAll('.product__variant-toggle');

    variantToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        this.closest('.product-item__image').classList.toggle('show-variant');
      });
    });
  })

  // 
  document.addEventListener('DOMContentLoaded', ()=> {
    const targetElement = document.querySelector("[data-related-section]");
    if (targetElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.type === "attributes") {
            const variantToggles = targetElement.querySelectorAll('.product__variant-toggle');

              variantToggles.forEach(toggle => {
                console.log(toggle);
                toggle.addEventListener('click', function() {
                  this.closest('.product-item__image').classList.toggle('show-variant');
                });
              });
          }
        });
      });
      
      const config = { attributes: false, childList: true, subtree: true };
      
      observer.observe(targetElement, config);
  
    }
  })


  // toggleActiveLink
  // const hashFirst = window.location.hash.slice(1); 
  const hashFirst = window.location.hash;
  
  if (window.location.pathname.includes('/account') && !window.location.pathname.includes('/account/addresses') && !window.location.pathname.includes('/account/orders')) {
    if (hashFirst === 'info' || hashFirst === 'order-history') {
      window.history.pushState({}, '', `${window.location.pathname}${hashFirst}`);
    }
  }

  function toggleActiveLink(linkId, isEmpty = false) {
    const elements = document.querySelectorAll('[data-active-link]');
    
    elements.forEach(element => {
        if (element.getAttribute('data-active-link') === linkId) {
            element.classList.add('is-current'); 
            if (!isEmpty) {
              element.closest('.account-container').classList.add('trigger');
            }
            if (linkId == 'info') {
              element.closest('.account-container').classList.add('active-info');
            }
            else {
              element.closest('.account-container').classList.remove('active-info');
            }
            
        } else {
            element.classList.remove('is-current');
        }
    });
  }

  function setActive() {
    const hash = window.location.hash.slice(1); 
    if(window.location.pathname.includes('/account')) {
      if(matchMedia('screen and (min-width: 750px)').matches && !window.location.pathname.includes('/addresses') && !window.location.pathname.includes('/orders')) {
        if (hash == '') {
          toggleActiveLink('info', true); 
        }
        if (hash == 'info' || hash == 'order-history') {
          toggleActiveLink(hash); 
        }
      }
      else if (!window.location.pathname.includes('/addresses') && !window.location.pathname.includes('/orders')) {
        if (hash == 'info' || hash == 'order-history') {
          toggleActiveLink(hash); 
        }
      } 
    }
  }

  setActive();

  window.addEventListener('resize', ()=> {
    const hash = window.location.hash.slice(1); 

    if (window.location.pathname.includes('/account')) {
      if(matchMedia('screen and (min-width: 750px)').matches && !window.location.pathname.includes('/account/addresses') && !window.location.pathname.includes('/account/orders')) {
        if (hash == '') {
          toggleActiveLink('info', true); 
        }
      }

      if (hash == 'info' || hash == 'order-history') {
        // console.log('123');
        toggleActiveLink(hash); 
      }
    }
  })
  window.addEventListener('hashchange', () => {
    const currentHash = window.location.hash;
    window.history.replaceState({}, '', `${window.location.pathname}${currentHash}`);
    const hash = window.location.hash.slice(1); 
    if (window.location.pathname.includes('/account') && !window.location.pathname.includes('/account/addresses')) {
      if (hash === 'info' || hash === 'order-history') {
        toggleActiveLink(hash); 
      }
      else if (hash == '' && matchMedia('screen and (min-width: 750px)').matches){
        // console.log('hash')
        toggleActiveLink('info', true); 
      }
    }
  });

  window.addEventListener("popstate", () => {
    const hash = window.location.hash.slice(1); 
    if(matchMedia('screen and (max-width: 749px)').matches) {
      if (window.location.pathname.includes('/account') && !window.location.pathname.includes('/account/addresses') && hash == '') {
        // console.log('popstate')
        window.location.reload();
      }
    }
  });

  // Convert currency
  function formatCurrency(currencyCode, amount) {
    const locale = window.locales[currencyCode] || 'ko-KR'; 
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(amount);
  }

  function updatePrices() {
    const priceElements = document.querySelectorAll('.total_price-order');

    priceElements && priceElements.forEach((element) => {
      // const price = parseFloat(element.dataset.price); 
      const price = parseFloat(element.dataset.price.replace(/,/g, '')); 
      const currency = element.dataset.currency; 

      if (!isNaN(price) && currency) {
        const formattedPrice = formatCurrency(currency, price);
        element.textContent = formattedPrice;
      } else {
        console.warn('Invalid data-price or data-currency in element:', element);
      }
    });
  }

  updatePrices();
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

